import { createFileRoute } from '@tanstack/react-router'
import AdminMetricsPage from '@/pages/admin/metrics'

export const Route = createFileRoute('/app/admin/metrics')({
  component: RouteComponent,
})

function RouteComponent() {
  return <AdminMetricsPage />
}
